import type React from 'react';
import classNames from 'classnames';
import Translation from '../../../general/Translation/Translation';
import styles from './GiftCardEditor.module.scss';
import { useTypedSelector } from '../../Store/connectors';
import Icon from '../../../../stories/Atoms/Icon/Icon';

interface Props {
  cartItemId: string;
  handleRemoveGiftCard: () => void;
  onOpenGiftCardEditor: () => void;
}

const GiftCardEditor: React.FC<Props> = ({
  cartItemId,
  handleRemoveGiftCard,
  onOpenGiftCardEditor,
}) => {
  const text = useTypedSelector(
    (state) => state.cartItems.items[cartItemId]?.giftCard.message ?? '',
  );

  return (
    <div className={styles.GiftCardEditor}>
      <div className={styles.GiftCardEditor__content}>
        <div className={styles.GiftCardEditor__content__status}>
          {text && (
            <Icon
              style="fa-solid"
              name="fa-check"
              className="mr-2"
            />
          )}
          {!text && (
            <Icon
              name="fa-envelope-open-text"
              className="mr-2"
            />
          )}
        </div>
        <div className={styles.GiftCardEditor__content__info}>
          <div
            className={classNames(
              styles.GiftCardEditor__content__info__title,
              'pointer',
            )}
            onClick={onOpenGiftCardEditor}
          >
            <Translation
              pageString="checkout"
              stringId="upsell-giftcard-text"
            />
          </div>
          {text && (
            <span
              className={styles.GiftCardEditor__content__info__subtitle}
              data-clarity-mask="True"
            >
              {text}
            </span>
          )}
        </div>
        <div className={styles.GiftCardEditor__content__actions}>
          {text && (
            <button
              data-clarity-mask="True"
              aria-label="Edit"
              className="button button--link"
              onClick={onOpenGiftCardEditor}
              data-testid="edit-giftcard-mobile"
            >
              <Translation
                pageString="winkelmand_teksten"
                stringId="edit"
              />
            </button>
          )}
          <button className="button button--link">
            {!text && (
              <span
                aria-label="Add"
                onClick={onOpenGiftCardEditor}
              >
                <Translation
                  pageString="checkout"
                  stringId="upsell-add-text"
                />
              </span>
            )}
            {text && (
              <span
                className="GiftCardEditor__content__actions_remove"
                onClick={handleRemoveGiftCard}
              >
                <Translation
                  pageString="class.bestelproces"
                  stringId="verwijderen"
                />
              </span>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GiftCardEditor;
